import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {map, tap} from 'rxjs/operators';
import {EditCourseComponent} from '../edit-course/edit-course.component';
import {AppState} from '../../store';
import {isLessonUploadOngoing} from '../../store/selectors';
import {MessagesService} from '../../shared/services/messages.service';


@Injectable({
  providedIn: 'root'
})
export class UploadOngoingGuard  {
  private store = inject<Store<AppState>>(Store);
  private messages = inject(MessagesService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {


  }

  // the param is unused; typed loosely so the route can host either the classic editor or the
  // redesigned builder shell (see course-builder/editor/edit-course-switcher/edit-course-switcher.component.ts)
  canDeactivate(component: unknown,
                currentRoute: ActivatedRouteSnapshot,
                currentState: RouterStateSnapshot,
                nextState?: RouterStateSnapshot): Observable<boolean> {

    return this.store
      .pipe(
        select(isLessonUploadOngoing),
        tap(isUploadOngoing => {
          if (isUploadOngoing) {
            this.messages.warn("Please wait until all uploads are completed and finished processing.");
          }
        }),
        map(isUploadOngoing => !isUploadOngoing)
      );
  }


}
